import React, { useContext } from "react"
import styled from "styled-components"
import AcIcon from "../atoms/AcIcon"
import { useCallVideoState } from "~/composable/useCallVideoStateZoom"
import { MessageType, UserType } from "../template/video/Meet"
import { selectTemporary } from "~/slices/temporarySlice"
import { useSelector } from "react-redux"
import { VideoContext } from "~/components/twilio/VideoProvider"
import { DATA_KEY } from "~/composable/useCallVideoStateZoom"

const tabData = [
  {
    id: 1,
    title: "ビデオ通話",
    iconName: "users-rectangle",
  },
  {
    id: 2,
    title: "画面共有 (書類表示)",
    iconName: "file-lines",
  },
  {
    id: 3,
    title: "電子サイン",
    iconName: "pen-nib",
  },
]

export default function AcCallVideoHeader() {
  const { sendData } = useContext(VideoContext)
  const { userType } = useSelector(selectTemporary)
  const { selectId, handleChangeTab } = useCallVideoState()
  const disabledTab = userType !== UserType.AGENT

  const handleTabClick = (tabId: number) => {
    if (disabledTab) return
    handleChangeTab(tabId)
    tabId !== 2 &&
      sendData({
        type: MessageType.NOTIFY,
        data: {
          [DATA_KEY.CHANGE_TAB]: { tabId },
        },
      })
  }

  return (
    <Header>
      <img src="/assets/img/logo.png" width={210} height={33} alt="AMBITION Cloud 電子契約" />
      <Tabs>
        {tabData.map((item) => (
          <TabItem
            key={item.id}
            className={item.id === selectId ? "active" : ""}
            onClick={() => handleTabClick(item.id)}
            disabled={disabledTab}
          >
            <AcIcon name={item.iconName} />
            {item.title}
          </TabItem>
        ))}
      </Tabs>
    </Header>
  )
}

const Header = styled.header`
  background-color: white;
  position: fixed;
  top: 0;
  z-index: 6;
  width: 100%;
  height: 55px;
  display: flex;
  flex-wrap: wrap;
  padding: 15px 25px 0;
  @media screen and (max-width: 920px) {
    height: 100px;
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
  }
`

const Tabs = styled.div`
  display: flex;
  padding: 0 20px;
  @media screen and (max-width: 920px) {
    width: 100%;
    padding: 10px 5px 0;
  }
`

const TabItem = styled.div`
  width: 200px;
  height: 40px;
  border-radius: 10px 10px 0 0;
  &:not(:first-child) {
    margin-left: 10px;
  }
  color: white;
  background-color: ${({ disabled }) => (disabled ? "#A8A8A8" : "#6b6bf9")};

  &.active {
    background-color: #ddddff;
    color: black;
  }

  white-space: nowrap;
  padding: 10px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    margin-right: 10px;
  }

  @media screen and (max-width: 460px) {
    padding: 10px 5px;
    font-size: 12px;
    &:not(:first-child) {
      margin-left: 7px;
    }
    i {
      margin-right: 5px;
    }
  }
`
